import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'core/translate';
import VehicleCard from '../VehicleCard/VehicleCard';

const BrandSection = props => {
  const { brand, bodyStyles, selectedYear, onViewInventoryClicked } = props;
  const filteredByYear = bodyStyles.filter(
    modelData => modelData.year === selectedYear
  );

  let vehicleCards;

  if (filteredByYear.length) {
    vehicleCards = filteredByYear.map((modelData, index) => (
      <VehicleCard
        key={index}
        modelData={modelData}
        onViewInventoryClicked={onViewInventoryClicked}
      />
    ));
  } else {
    vehicleCards = (
      <div className="no-models-to-display">
        <Translate value="model.selector.year.none" />
      </div>
    );
  }

  return (
    <section className="brand-section">
      <div>
        <div className="brand-section__name">
          <Translate value={brand} />
        </div>
        <div className="vehicle-cards">{vehicleCards}</div>
      </div>
    </section>
  );
};

BrandSection.propTypes = {
  brand: PropTypes.string.isRequired,
  bodyStyles: PropTypes.array.isRequired
};

export default BrandSection;
